import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';

import { MyApp } from './app.component';
import { AddBviLeadsPage } from '../pages/add-bvi-leads/add-bvi-leads';
import { AddUserPage } from '../pages/add-user/add-user';
import { AgencySetupPage } from '../pages/agency-setup/agency-setup'
import { ApiTearSheetPage } from '../pages/api-tear-sheet/api-tear-sheet';
import { EditEndpointsPage } from '../pages/edit-endpoints/edit-endpoints';
import { EditUserPage } from '../pages/edit-user/edit-user';
import { FileUploadPage } from '../pages/file-upload/file-upload';
import { HomePage } from '../pages/home/home';
import { LoginPage } from '../pages/login/login';
import { UserManagementPage } from '../pages/user-management/user-management';
import { UserOverviewPage } from '../pages/user-overview/user-overview';
import { CompliancePage } from '../pages/compliance/compliance';
import { ComplianceDomainPage } from '../pages/compliance-domain/compliance-domain';

import { AccountProvider } from '../providers/account/account';
import { AwsProvider } from '../providers/aws/aws';
import { UsersProvider } from '../providers/users/users';

@NgModule({
  declarations: [
    MyApp,
    AddBviLeadsPage,
    AddUserPage,
    AgencySetupPage,
    ApiTearSheetPage,
    EditEndpointsPage,
    EditUserPage,
    FileUploadPage,
    HomePage,
    LoginPage,
    UserManagementPage,
    UserOverviewPage,
    CompliancePage,
    ComplianceDomainPage
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    IonicModule.forRoot(MyApp),
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    AddBviLeadsPage,
    AddUserPage,
    AgencySetupPage,
    ApiTearSheetPage,
    EditEndpointsPage,
    EditUserPage,
    FileUploadPage,
    HomePage,
    LoginPage,
    UserManagementPage,
    UserOverviewPage,
    CompliancePage,
    ComplianceDomainPage
  ],
  providers: [
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    AccountProvider,
    AwsProvider,
    UsersProvider,
    InAppBrowser,
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts